export default {
  name: 'Index',
  data() {
    return {
      // 版本号
      version: '3.8.8'
    };
  },
  methods: {
    goTarget(href) {
      window.open(href, '_blank');
    }
  }
};